import * as RadixDialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '../lib/cn.js';

export interface DialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  children?: ReactNode;
  footer?: ReactNode;
  className?: string;
}

/** Modale dialoog op Radix: focus trap, Escape en aria-labelling zitten in de primitief. */
export function Dialog({
  open,
  onOpenChange,
  title,
  description,
  children,
  footer,
  className,
}: DialogProps) {
  return (
    <RadixDialog.Root open={open} onOpenChange={onOpenChange}>
      <RadixDialog.Portal>
        <RadixDialog.Overlay className="fixed inset-0 z-40 bg-[rgba(26,29,46,0.45)]" />
        <RadixDialog.Content
          className={cn(
            'fixed left-1/2 top-1/2 z-50 w-[min(92vw,520px)] -translate-x-1/2 -translate-y-1/2',
            'rounded-xl border border-border bg-surface p-card shadow-lg',
            className,
          )}
        >
          <div className="mb-element flex items-start justify-between gap-element">
            <div>
              <RadixDialog.Title className="font-heading text-title-lg font-semibold text-text-primary">
                {title}
              </RadixDialog.Title>
              {description ? (
                <RadixDialog.Description className="mt-1 text-content text-text-secondary">
                  {description}
                </RadixDialog.Description>
              ) : null}
            </div>
            <RadixDialog.Close
              aria-label="Sluiten"
              className="inline-flex h-10 w-10 items-center justify-center rounded-pill text-text-secondary hover:bg-background hover:text-brand-primary"
            >
              <X aria-hidden className="h-4 w-4" />
            </RadixDialog.Close>
          </div>
          {children}
          {footer ? <div className="mt-card flex justify-end gap-inline">{footer}</div> : null}
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  );
}
